module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_3016.8265910b.png";